import React from 'react';
import TimeWithPopUp from './TimeWithPopup';

class ClassCard extends React.Component {

    render() {

        return (
            <div className="card">
                <div className="card-header">
                    {this.props.cls.S} {this.props.cls.CN} {this.props.cls.CS}<br />
                    {this.props.cls.T}
                    <div className="float-right" style={{ position: "absolute", top: 5, right: 5 }}>
                        <button type="button" className="close" aria-label="Close" id={this.props.cls.CLASS_NBR} onClick={this.props.removeCompare}>
                            <span aria-hidden="true" id={this.props.cls.CLASS_NBR}>&times;</span>
                        </button>
                    </div>
                </div>
                <div className="card-body m-0 p-0">
                    <table className="table">
                        <tbody>
                            <tr>
                                <td>Location:</td>
                                <td>{this.props.cls.LOC_D}</td>
                            </tr>
                            <tr>
                                <td>Class number:</td>
                                <td>{this.props.cls.CLASS_NBR}<br /></td>
                            </tr>
                            <tr>
                                <td>Credits:</td>
                                <td>{this.props.cls.CR}<br /></td>
                            </tr>
                            <tr>
                                <td>Dates:</td>
                                <td>{new Date(this.props.cls.START_DT).toLocaleDateString('en-US')} - {new Date(this.props.cls.END_DT).toLocaleDateString('en-US')}</td>
                            </tr>
                            <tr>
                                <td>Time:</td>
                                <td><TimeWithPopUp cls={this.props.cls} downrangeLocations={this.props.downrangeLocations} showLabel="false"/></td>
                            </tr>
                            <tr><td>Days:</td>
                                <td>
                                    {this.props.cls.MON === "Y" ? "Mon " : ""}
                                    {this.props.cls.TUES === "Y" ? "Tue " : ""}
                                    {this.props.cls.WED === "Y" ? "Wed " : ""}
                                    {this.props.cls.THURS === "Y" ? "Thu " : ""}
                                    {this.props.cls.FRI === "Y" ? "Fri " : ""}
                                    {this.props.cls.SAT === "Y" ? "Sat " : ""}
                                    {this.props.cls.SUN === "Y" ? "Sun " : ""}
                                </td>
                            </tr>
                            <tr>
                                <td>Faculty:</td>
                                <td>{this.props.cls.FAC.replace(",",", ")}</td>
                            </tr>
                            <tr>
                                <td colSpan="2">{this.props.cls.UC_DESCR254_NOTES}</td>
                            </tr>
                            <tr>
                                <td colSpan="2">{this.props.cls.DESCRIPTION}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default ClassCard;